import { render, staticRenderFns } from "./BAutocompleteUsers.vue?vue&type=template&id=60e3faa3&"
import script from "./BAutocompleteUsers.vue?vue&type=script&lang=js&"
export * from "./BAutocompleteUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports